export default "__VITE_ASSET__6e87542e__"